import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {EmailTemplateService} from '../../../services';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { SharedService } from '../../../../shared/services/shared.service';


@Component({
  selector: 'app-email-template-view',
  templateUrl: './email-template-view.component.html',
  styleUrls: ['./email-template-view.component.css']
})
export class EmailTemplateViewComponent implements OnInit {

  emailTemplateDetail: any;
  tempid: number =0;

  constructor(private spinner: NgxSpinnerService,
    private emailTemplateService:EmailTemplateService,
    private route: ActivatedRoute,private router: Router,
    public sharedService: SharedService,
    ) { }

  ngOnInit(): void {
    this.checkViewPermission();
    this.route.queryParams
      .subscribe(params => {
        console.log(params);
        this.tempid = params.id;
        console.log("id value is "+this.tempid);
      }
    );

    if(this.tempid>0)
    {
      this.getEmailTemplateDetails();
    }
  }

  checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this.router.navigateByUrl('/login');
   }

  getEmailTemplateDetails()
  {
      this.emailTemplateService.getEmailTemplateById(this.tempid).subscribe((data: any) => {
      this.emailTemplateDetail = data;
      console.log('this.emailTemplateDetail');
      console.log(this.emailTemplateDetail);
     });
  }

  cancel()
  {
    this.router.navigate(['/email-template']);
  }

}
